@use '@lib/assets/styles/main.scss' as *;

.wrapper,
.listWrapper {
  width: 100%;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 244px;
}

.item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.buttonItemWrap {
  display: flex;
}

.buttonItem {
  @extend .item;
  cursor: pointer;
  background: none;
  border: none;
}

.staticItem {
  @extend .item;
  cursor: default;
}

.carouselItem {
  width: 100%;
}

.preview {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 120px;
  overflow: hidden;
}

.thumbnail {
  display: block;
  width: auto;
  height: auto;
  object-fit: contain;
}

.previewPlaceholder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  width: 100%;
}
